import moment from "moment";
import React from "react";
import { Col } from "reactstrap";
import {
  ChangeBookingStatus,
  RemoveBookingDates,
  sendNotifications,
} from "../util/api";
import { useNavigate } from "react-router-dom";

const CustomerDetails = (props) => {
  const { data } = props;
  const navigate = useNavigate();
  return (
    <Col>
      <div style={{ display: "flex", alignItems: "center" }}>
        <h3>{moment(data?.tripStartDate).format("DD-mm-yyyy hh:mm A")}</h3>
        <h1 style={{ marginLeft: 10, marginRight: 10 }}>To</h1>
        <h3>{moment(data?.tripStartDate).format("DD-mm-yyyy hh:mm A")}</h3>
      </div>
      <div>
        <h1>Delivery</h1>
        <p>{data?.tripPickUpLocation}</p>
      </div>
      <button
        style={{ width: 100, backgroundColor: "transparent" }}
        onClick={() => {
          let obj = {
            bookingExternalId: data?.bookingExternalId,
            bookingStatus: "CanceledByCustomer",
          };
          ChangeBookingStatus(obj).then((res) => {
            if (res?.success == true) {
              let notifyObj = {
                id: 0,
                notificationText: `Your trip of ${
                  data.brandName + " " + data.carName
                } has been canceled`,
                seenStatus: false,
                screenName: "TripsScreen",
                notificationDate: moment(),
                userId: data.customerId,
              };
              sendNotifications(notifyObj).then((res) => {
                RemoveBookingDates(data.bookingExternalId).then((res) => {
                  console.log("here", res);
                  navigate("/");
                });
              });
            }
          });
        }}
      >
        Cancel Trip
      </button>
    </Col>
  );
};
export default CustomerDetails;
